import { render, staticRenderFns } from "./Course-Level.vue?vue&type=template&id=f295dd04&scoped=true"
import script from "./Course-Level.vue?vue&type=script&lang=js"
export * from "./Course-Level.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f295dd04",
  null
  
)

export default component.exports